import React, { useState } from "react";
import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

import { PlusIcon } from "../../Icons";
import { SubmitButton } from "../Button/SubmitButton";

export const NextSubmitButton = styled(SubmitButton)({
  border: "1px solid #BF295C",
  color: "#BF295C",
  backgroundColor: "#FAFAFA",
  "&:hover, &:active": {
    backgroundColor: "#FFF8FA",
  },
  "&:disabled": {
    borderColor: "#D6D6DB",
  },
});

interface EmptyPageStateProps {
  image: string;
  title: string;
  subTitle: string;
  buttonText?: string;
  hiddenElement?: () => string | undefined;
  onButtonClick?: () => void;
}

export const EmptyPageState = ({
  image,
  title,
  subTitle,
  buttonText,
  hiddenElement,
  onButtonClick,
}: EmptyPageStateProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexAlign: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "564px",
          textAlign: "center",
        }}
      >
        <img
          src={image}
          style={{
            height: 268,
            objectFit: "contain",
            marginTop: "86px",
            marginBottom: "60px",
          }}
        />
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#080808",
            marginBottom: "18px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "18px",
            color: "#363636",
            marginBottom: "48px",
          }}
        >
          {subTitle}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {buttonText != null && (
            <SubmitButton
              title={buttonText}
              endIcon={<PlusIcon />}
              onClick={onButtonClick}
              sx={{
                width: "184px",
                marginBottom: "16px",
                display: hiddenElement,
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
